import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Color, Font } from '@figure/frontlib-gui';

export const PureBody = styled.p.attrs((props) => props)`
  font-family: ${Font.PRIMARY_FONT};
  color: ${Color.BLACK_SOUL};
  letter-spacing: 0.35px;
  margin: 0;
`;

/**
 * Base body element, allowing to pass different semantic
 * elements to use as a base.
 *
 * PureBody defines common body styles,
 * BodyBase sets up passing a semantic element
 *
 * A specific Body, such as SmallBodyBold, consumes it,
 * and adds its specific styles.
 *
 * Example:
 *
 * export const SmallBodyBold = styled(BodyBase)`
 *   font-size: 1.3rem;
 *   font-weight: 600;
 * `;
 *
 * import * as Typography from 'components/Component/UI/Typography';
 *
 * <Typography.SmallBodyBold semanticElement="span">
 *   Hello
 * </Typography.SmallBodyBold>
 */
const BodyBase = ({ semanticElement, className, children, ...rest }) => (
  <PureBody as={semanticElement} className={className} {...rest}>
    {children}
  </PureBody>
);

BodyBase.propTypes = {
  semanticElement: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

BodyBase.defaultProps = {
  semanticElement: 'p',
  className: '',
  children: null,
};

export default BodyBase;
